export default "__VITE_ASSET__B_BMEsGZ__$_?url__"